import { LinkGroupHeading } from '@components/linkGroup';
import { LinkList } from '@components/linkList';
import { useFragment } from 'react-relay';
import { linkListGroupFragment } from './LinkListGroup.relay';
import type { LinkListGroupPropsType } from './types';

const LinkListGroup: React.FC<LinkListGroupPropsType> = (props: LinkListGroupPropsType) => {
  const frontGroup = useFragment(linkListGroupFragment, props.frontGroup);

  return (
    <div>
      <LinkGroupHeading>{frontGroup.title}</LinkGroupHeading>
      {frontGroup.linkLists.map((linkList, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: is static
        <LinkList key={index} linkList={linkList} />
      ))}
    </div>
  );
};

export { LinkListGroup };
